const css = `.external-users-dropdown-button {
  position: relative;
}
.external-users-dropdown-button .button-container {
  display: inline-block;
}
.external-users-dropdown-button .add-button {
  color: var(--primary-color);
  font-weight: var(--font-weight-medium);
  padding: 8px;
  min-height: auto;
}
.external-users-dropdown-button .add-button:hover {
  background: var(--accent-subtle);
  border-radius: var(--border-radius);
}
.external-users-dropdown-button .add-button .p-button-icon {
  margin-right: 8px;
}
.external-users-dropdown-button .custom-dropdown-container {
  position: absolute;
  z-index: 1000;
  width: 250px;
  max-width: 100vw;
  overflow: visible;
}
.external-users-dropdown-button .custom-dropdown-container .custom-dropdown {
  background-color: var(--surface-overlay);
  border-radius: var(--border-radius);
  border: 1px solid var(--border);
  box-shadow: none;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.external-users-dropdown-button .custom-dropdown-container .custom-dropdown .dropdown-search {
  padding: 12px;
  border-bottom: 1px solid var(--surface-border);
  flex-shrink: 0;
}
.external-users-dropdown-button .custom-dropdown-container .custom-dropdown .dropdown-search .p-inputtext {
  width: 100%;
}
.external-users-dropdown-button .custom-dropdown-container .custom-dropdown .dropdown-options-list {
  max-height: 300px;
  overflow-y: auto;
  flex-grow: 1;
}
.external-users-dropdown-button .custom-dropdown-container .custom-dropdown .dropdown-options-list .dropdown-option-wrapper {
  cursor: pointer;
  padding: 8px;
}
.external-users-dropdown-button .custom-dropdown-container .custom-dropdown .dropdown-options-list .dropdown-option-wrapper:hover {
  background-color: var(--surface-hover);
}
.external-users-dropdown-button .custom-dropdown-container .custom-dropdown .dropdown-options-list .empty-message {
  padding: 16px;
  text-align: center;
  color: var(--text-color-secondary);
}

.external-users-select-modal {
  width: 90vw;
  max-width: 750px;
  max-height: 80vh;
}
.external-users-select-modal .p-dialog-content {
  padding: 0;
}
.external-users-select-modal .user-select-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}
.external-users-select-modal .user-select-content .user-select-search {
  width: 100%;
}
.external-users-select-modal .user-select-content .user-select-search .p-inputtext {
  width: 100%;
}
.external-users-select-modal .user-select-content .user-options-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
}
.external-users-select-modal .user-select-content .user-options-list .user-option-wrapper {
  cursor: pointer;
  border-radius: var(--border-radius);
  padding: 8px;
}
.external-users-select-modal .user-select-content .user-options-list .user-option-wrapper:hover {
  background-color: var(--surface-hover);
}
.external-users-select-modal .user-select-content .empty-message {
  padding: 16px;
  text-align: center;
  color: var(--text-color-secondary);
}
@media screen and (max-width: 768px) {
  .external-users-select-modal .p-dialog-content {
    max-height: calc(80vh - 70px) !important;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
